import messages = require("../front/messages");

function performInBrowserHttpRequest(
	request: XMLHttpRequest,
	url: string,
	method: "POST" | "GET" | "DELETE",
	listener: (request: XMLHttpRequest) => void,
	data?: File
) {
	request.onload = function () {
		if (request.status >= 200 && request.status < 300) {
			listener(request);
		} else {
			warningMessage("Bad status code: " + request.status);
		}
	};
	request.onabort = function () {
		warningMessage("Request aborted.");
	};
	request.onerror = function () {
		warningMessage("Request error.");
	};
	request.open(method, window.location.origin + window.location.pathname + global.file_storage_url + url);
	request.send(data);
}

function warningMessage(error: string) {
	console.warn(error);
	messages.addMessage("warning", "Something went wrong. Please try again.");
}

export function download_from_files_resource(token: string): Promise<any> {
	const request = new XMLHttpRequest();
	request.responseType = "blob";
	return new Promise((resolve) => {
		performInBrowserHttpRequest(request, "/" + token, "GET", function (request) {
			if (request.responseType === "blob") {
				resolve(request.response);
			} else {
				resolve(request.responseText);
			}
		});
	});
}

export async function uploadToFilesResource(file: File): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		performInBrowserHttpRequest(
			new XMLHttpRequest(),
			"",
			"POST",
			function (request) {
				const response = JSON.parse(request.responseText)["reply type"];
				if (response[0] === "upload" && response[1].result[0] === "success") {
					resolve(response[1].result[1].token);
				} else {
					warningMessage("File could not be uploaded. The files resource did not accept the file.");
					reject("File could not be uploaded. The files resource did not accept the file.");
				}
			},
			file
		);
	});
}

export function deleteFromFilesResource(token: string): Promise<void> {
	return new Promise((resolve) => {
		performInBrowserHttpRequest(new XMLHttpRequest(), "/" + token, "DELETE", function (request) {
			const response = JSON.parse(request.responseText)["reply type"];
			if (response[0] === "delete" && response[1].result[0] === "success") {
				resolve();
			} else {
				warningMessage("File could not be deleted. The files resource did not accept the request.");
			}
		});
	});
}
